<!-- 消息通知 -->
<template>
	<!-- <div ref="mainBox"> -->
	<el-container class="box">
		<el-main>
			<template v-for="(testInfo,index) in testInfoData">
				<el-row :gutter="24" v-bind:key="testInfo.id">
					<el-col :span="10">
						<div class="grid-content imgBox">
							<img alt="" :src="bindImage(testInfo.taskImage)">
						</div>
					</el-col>
					<el-col :span="14">
						<div class="grid-content textBox">
							<span class="title">{{testInfo.name}}</span>
							<span class="textArea" v-html="testInfo.description"></span>
							<el-button type="info" class="btnStart" disabled v-if="testInfo.status == 'DONE'">已完成</el-button>
							<el-button type="primary" class="btnStart" @click="btnStart(testInfo,apiInfo)" v-if="testInfo.status == 'UNDONE'">开始测试</el-button>
							<!-- <router-link :to="{name:'online', query: {testInfoName: testInfo.name, bizId: apiInfo.examScoreBizId, testInfoId: testInfo.id}}">
								<el-button type="primary" class="btnStart" v-if="testInfo.status == 'UNDONE'"></el-button>
							</router-link> -->
							<img alt="" src="@/assets/img/online/bu_tag.png" class="buTag">
							<span class="pgzx">{{buId[testInfo.type]}}</span>
						</div>
					</el-col>
				</el-row>
			</template>
		</el-main>
	</el-container>
	<!-- <template v-for="(testInfo,index) in testInfoData"> -->

	<!-- {{testInfo.name}}
			<router-link :to="{name:'online', query: {testInfoName: testInfo.name, testInfoId: testInfo.id}}">
				<el-button type="info" v-if="testInfo.status == 'DONE'">已经完成测试</el-button>
				<el-button type="primary" v-if="testInfo.status == 'UNDONE'">开始测试</el-button>
			</router-link> -->
	<!-- </template>
	</div> -->
</template>
<script>
	/* eslint-disable */
	export default {
		components: {},
		data() {
			return {
				apiInfo: {
					token: '',
					// url地址示例:http://localhost:8001/#/start?examScoreBizId=ff80808172318b0e0173ad1656d15a2d&examTaskIdList=1310415516250259458,1310415516350922755
					examScoreBizId: '',
					examTaskIdList: []
				},
				testInfoData: {

				},
				buId: {
					10: "评估中心",
					20: "其它部门"
				}
			}
		},
		created() {
			var that = this;
			this.$eventHub.$on('completeSurvey', (data) => {
				this.refreshData()
			})
		},
		mounted() {
			var that = this;
			// 获取地址栏参数
			this.apiInfo.examScoreBizId = this.$route.query.examScoreBizId;
			this.apiInfo.examTaskIdList = this.$route.query.examTaskIdList;
			let token = sessionStorage.getItem('oauth_token')
			if (!token) {
				this.$message.warning(this.$t('res.getCheckTokenError')) // 获取access_token失败
				return;
				//this.checkAccessTokenForZCHC(token)
			} else {
				this.apiInfo.token = token;
				// 查看在线测评任务完成情况
				this.$request.get('/online/exam/taskFinishedStatus', {
					examScoreBizId: this.apiInfo.examScoreBizId,
					examTaskIdList: this.apiInfo.examTaskIdList
				}).then((res, total, code, data) => {
					if (code == 1) {
						console.log(res)
						this.testInfoData = res;
					} else {
						this.$message.warning(data.msg)
					}
				}).catch((error) => {
					this.$message.warning(error)
				})
			}
		},
		methods: {
			bindImage(img) {
				return require("@/assets/img/online/"+img);
			},
			refreshData(){
				this.$request.get('/online/exam/taskFinishedStatus', {
					examScoreBizId: this.apiInfo.examScoreBizId,
					examTaskIdList: this.apiInfo.examTaskIdList
				}).then((res, total, code, data) => {
					if (code == 1) {
						console.log(res)
						this.testInfoData = res;
					} else {
						this.$message.warning(data.msg)
					}
				}).catch((error) => {
					this.$message.warning(error)
				})
			},
			btnStart(testInfo,apiInfo){//开始测试
				this.$router.push({
					name:'online-online',
					query: {testInfoName: testInfo.name, bizId: apiInfo.examScoreBizId, testInfoId: testInfo.id}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.box {

		.el-main {
			background: #ffffff;
		}

		.el-row {
			padding-bottom: 20px;
			border-bottom: 1px solid #d6d6d6;
			padding-top: 20px;
			min-height: 240px;

			&:last-child {
				padding-bottom: 0;
				border-bottom: 0px solid #d6d6d6;
			}

			&:first-child {
				padding-top: 0;
			}
		}

		.el-col {
			border-radius: 4px;

			.imgBox img {
				width: 100%;
			}
		}

		.title {
			font-size: 20px;
			font-weight: bold;
			margin-bottom: 0.8em;
			display: block;
		}

		.textArea {
			font-size: 16px;
			line-height: 2em;
			margin-bottom: 1em;
			max-width: 80%;
			display: block;
		}

		.btnStart {
			margin-top: 20px;
			width: 220px;
			height: 50px;
			font-size: 16px;
			font-weight: bold;
		}

		.el-button--info:hover,
		.el-button--info:active,
		.el-button--info:focus {
			background-color: #909399 !important;
		}
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.row-bg {
		padding: 10px 0;
		background-color: #f9fafc;
	}

	.textBox {
		position: relative;

		.buTag {
			position: absolute;
			right: -20px;
			top: -20px;
		}

		.pgzx {
			display: block;
			position: absolute;
			right: -1px;
			top: 23px;
			color: white;
			font-size: 18px;
			font-weight: bold;
			transform: rotate(45deg);
		}
	}
</style>
